import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Avatar, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.AvatarTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.AvatarTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.AvatarTypeConst.CLASS) ?? '']: true, 'customrequired': _ctx.getPropertyBooleanValue(_ctx.AvatarTypeConst.REQUIRED) }),
        name: _ctx.getPropertyValue(_ctx.AvatarTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.AvatarTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.AvatarTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.AvatarTypeConst.PLACEHOLDER),
        label: _ctx.getPropertyValue(_ctx.AvatarTypeConst.LABEL),
        icon: _ctx.getPropertyValue(_ctx.AvatarTypeConst.ICON),
        size: _ctx.getCatalogValue(_ctx.AvatarTypeConst.SIZE),
        image: _ctx.getPropertyValue(_ctx.AvatarTypeConst.IMAGE),
        shape: _ctx.getCatalogValue(_ctx.AvatarTypeConst.SHAPE),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
        onClick: _ctx.clicktest
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "label", "icon", "size", "image", "shape", "modelValue", "onClick"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.AvatarTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}